import {
	WeaTools
} from 'ecCom'

export const getKQReport = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQReportInfo', 'POST', params);
}

export const getKQCarendarReport = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQMonthReportInfo', 'POST', params);
}

export const getHrmKQSignInfo = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQSignInfo', 'POST', params);
}


export const getTableData = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQReportDetialInfo', 'POST', params);
}

export const getHrmNewWorkflwList = params => {
	return WeaTools.callApi('/api/hrm/kq/report/getHrmNewWorkflwList', 'GET', params);
}

export const getHrmKQReportDetialInfo = params => {
	return WeaTools.callApi('/api/kq/myattendance/getHrmKQReportDetialInfo', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/apis/checking.js